import { provideLocationState } from "components/utility/hoc/LocationState";
var Modal = require("components/utility/AltModal");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var CurrentUser = require("lib/account/CurrentUser");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var Preferences = require("components/users/teachers/Preferences");
var AccountCustomizer = require("components/users/teachers/AccountCustomizer");
var Features = require("lib/account/Features");
var AccountPlans = require("lib/account/AccountPlans");
var SettingsRouting = require("lib/routing/SettingsRouting");

require("users/teachers/settings_page.scss");
@provideLocationState(SettingsRouting.getRouteState)
class SettingsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {};
		LuckyOrangeClient.tagComponent("SettingsPage");
	}

	fetchBillingHistory()  {
		CurrentUser.api().getUser(CurrentUser.get().id, { embed: "user.billing_history" }, (response) => {
			this.setState({ billingHistory: response.user.billing_history || [] });
		});
	}

	onViewChange(view) {
		this.changeView({ activeView: view });
		if ($wr.capitalize(view) == Preferences.PAYMENT) {
			this.fetchBillingHistory()
		}
	}
	changeView(update) {
		var newLocationState = _.extend({}, this.props.locationState, update)
		$wr.redirect(SettingsRouting.getPath(newLocationState));
	}
	selectPreference(preference) {
		this.onViewChange(preference)
	}
	getPreferenceName(preference) {
		if (preference == SKILLSET_CUSTOMIZER) {
			return Preferences.SKILLSET_CUSTOMIZER;
		} else if (preference == DISPLAY_CLASS_SHELF) {
			return Preferences.DISPLAY_CLASS_SHELF;
		} else if (preference == QUIZ_SCORING) {
			return Preferences.QUIZ_SCORING;
		} else if (preference == BACK_LOG_DATE_PERIOD) {
			return Preferences.BACK_LOG_DATE_PERIOD;
		} else if (preference == ALLOW_STUDENT_WRITING_DELETION) {
			return Preferences.ALLOW_STUDENT_WRITING_DELETION;
		} else if (preference == QUESTION_CUSTOMIZER) {
			return Preferences.QUESTION_CUSTOMIZER;
		} else if (preference == SPEECH_CONTROLS) {
			return Preferences.SPEECH_CONTROLS;
		} else if (preference == SCHOOL_YEAR) {
			return Preferences.SCHOOL_YEAR;
		} else if (preference == SOUND_OPTION) {
			return Preferences.SOUND_OPTION;
		} else if (preference == OWL_SHOP) {
			return Preferences.OWL_SHOP;
		} else if (preference == INFORMATION) {
			return Preferences.INFORMATION;
		} else if (preference == PAYMENT) {
			return Preferences.PAYMENT;
		} else if (preference == PLAN) {
			return Preferences.PLAN;
		} else if (preference == ZPD) {
			return Preferences.ZPD;
		} else if (preference == REFERRAL) {
			return Preferences.REFERRAL;
		} else if (preference == ALLOW_STUDENT_QUESTION_BUILDER) {
			return Preferences.ALLOW_STUDENT_QUESTION_BUILDER;
		} else if (preference == CODE_TABLE) {
			return Preferences.CODE_TABLE;
		} else if (preference == LINK_ACCOUNTS) {
			return Preferences.LINK_ACCOUNTS;
		} else if (preference == QUIZ_LIMIT) {
			return Preferences.QUIZ_LIMIT
		} else if (preference == ROSTERING_METHOD) {
			return Preferences.ROSTERING_METHOD
		} else if (preference == ACTIVATION_CODES) {
			return Preferences.ACTIVATION_CODES
		} else if (preference == GENERAL_ORG_SETTINGS) {
			return Preferences.GENERAL_ORG_SETTINGS
		} else if (preference == MERGE_USERS) {
			return Preferences.MERGE_USERS
		} else if (preference == SCHOOL_CONTEST) {
			return Preferences.SCHOOL_CONTEST
		}
	}
	getSubHeaderName(preference) {
		if (preference == INFORMATION || preference == QUIZ_SCORING || preference == SKILLSET_CUSTOMIZER || preference == QUESTION_CUSTOMIZER || preference == SOUND_OPTION) {
			return preference;
		} else if (preference == BACK_LOG_DATE_PERIOD) {
			return "Log Reading";
		} else if(preference == PLAN){
			return "Status";
		} else if (preference == ALLOW_STUDENT_WRITING_DELETION) {
			return "Delete Writing";
		} else if (preference == SPEECH_CONTROLS) {
			return "Voice Options";
		} else if (preference == SCHOOL_YEAR) {
			return "School Year";
		} else if (preference == OWL_SHOP) {
			return "Owl Shop Hours";
		} else if (preference == ZPD) {
			return "Reading Level";
		} else if (preference == PAYMENT) {
			return "Billing";
		} else if (preference == DISPLAY_CLASS_SHELF) {
			return "Class Shelf";
		} else if (preference == REFERRAL) {
			return "Referrals"
		} else if (preference == ALLOW_STUDENT_QUESTION_BUILDER) {
			return "Question Builder";
		} else if (preference == CODE_TABLE) {
			return "Setup Progress"
		} else if (preference == LINK_ACCOUNTS) {
			return "Link Accounts"
		} else if (preference == QUIZ_LIMIT){
			return "Quiz Hours"
		} else if (preference == ROSTERING_METHOD){
			return "Rostering Method"
		} else if (preference == ACTIVATION_CODES){
			return "Activation Codes"
		} else if (preference == GENERAL_ORG_SETTINGS){
			if (CurrentUser.isTeacherAdmin()) {
				return "Expecations"
			} else {
				return "General Settings"
			}
		} else if (preference == MERGE_USERS) {
			return "Merge Users"
		} else if (preference == SCHOOL_CONTEST) {
			return "School Contest"
		}
	}
	componentDidUpdate() {
		if (!this.props.locationState.activeView) {
			this.changeView({ activeView: INFORMATION });
		}
	}

	preferenceClassName(preference) {
		return (this.props.locationState.activeView == preference) ? "selected" : "";
	};

	renderAccountSection() {
		var { activeView } = this.props.locationState;

		var merge = (
			<a onClick={this.selectPreference.bind(this, MERGE_USERS)}
				className={this.preferenceClassName(MERGE_USERS)}>
				Merge Users
			</a>
		)

		var link = (
			<a onClick={this.selectPreference.bind(this, LINK_ACCOUNTS)}
				className={this.preferenceClassName(LINK_ACCOUNTS)}>
				Link Accounts
			</a>
		)

		if (CurrentUser.isTeacherAdmin()) {
			if (CurrentUser.isPayingUser()){
				var billingHistory = (
					<a onClick={ this.selectPreference.bind(this, PAYMENT) }
						className={ this.preferenceClassName(PAYMENT) }>
						Billing
					</a>
				);
			} else { 
				var billingHistory = null 
			}
			var plan = (
				<a onClick={ this.selectPreference.bind(this, PLAN) }
					className={ this.preferenceClassName(PLAN) }>
					Status
				</a>
			);
		}
		return (
			<div className="linksGroup">
				<p>Account</p>
				<a onClick={ this.selectPreference.bind(this, INFORMATION) } 
					className={ this.preferenceClassName(INFORMATION) }>
					Information
				</a>
				{CurrentUser.isTeacherAdmin()? 
					<div>
						{billingHistory}
						{plan}
						{link}
						{merge}
					</div>
					:
					<div>
						{link}
					</div>
				}
			</div>
		);
	}

	renderOrgSection() {
		var orgLabel = null;

		if (CurrentUser.isSchoolAdmin()) {
			orgLabel = "School"
		} else if (CurrentUser.isDistrictAdmin()) {
			orgLabel = "District"
		}

		if (!orgLabel) {
			return ;
		}

		var { activeView } = this.props.locationState;
		return (
			<div className="linksGroup">
				<p>{orgLabel}</p>
				<a onClick={ this.selectPreference.bind(this, GENERAL_ORG_SETTINGS) }
					className={ this.preferenceClassName(GENERAL_ORG_SETTINGS) }>
					General Settings
				</a>
				<a onClick={ this.selectPreference.bind(this, ROSTERING_METHOD) }
					className={ this.preferenceClassName(ROSTERING_METHOD) }>
					Rostering Method
				</a>
				<a onClick={ this.selectPreference.bind(this, ACTIVATION_CODES) }
					className={ this.preferenceClassName(ACTIVATION_CODES) }>
					Activation Codes
				</a>
				<a onClick={this.selectPreference.bind(this, CODE_TABLE)}
					className={this.preferenceClassName(CODE_TABLE)}>
					Setup Progress
				</a>
				<a onClick={ this.selectPreference.bind(this, SCHOOL_CONTEST) }
					className={ this.preferenceClassName(SCHOOL_CONTEST) }>
					School Contest
				</a>
			</div>
		);
	}

	renderContentSection() {
		if (!CurrentUser.isTeacherAdmin()) {
			return;
		}

		var { activeView } = this.props.locationState;
		return (
			<div className="linksGroup">
				<p>Content</p>
				<a onClick={ this.selectPreference.bind(this, QUESTION_CUSTOMIZER) }
					className={ this.preferenceClassName(QUESTION_CUSTOMIZER) }>
					Questions
				</a>
				<a onClick={ this.selectPreference.bind(this, ZPD) }
					className={ this.preferenceClassName(ZPD) }>
					Reading Level
				</a>
				<a onClick={ this.selectPreference.bind(this, SKILLSET_CUSTOMIZER) } 
					className={ this.preferenceClassName(SKILLSET_CUSTOMIZER) }>
					Standards
				</a>
				<a onClick={ this.selectPreference.bind(this,  ALLOW_STUDENT_QUESTION_BUILDER) } 
					className={ this.preferenceClassName(ALLOW_STUDENT_QUESTION_BUILDER) }>
					Question Builder
				</a>
			</div>
		)
	}

	renderStudentsSection() {
		if (!CurrentUser.isTeacherAdmin()) {
			return;
		}

		var { activeView } = this.props.locationState;
		return (
			<div className="linksGroup">
				<p>Students</p>
				<a onClick={ this.selectPreference.bind(this, DISPLAY_CLASS_SHELF) }
					className={ this.preferenceClassName(DISPLAY_CLASS_SHELF) }>
					Class Shelf
				</a>
				<a onClick={ this.selectPreference.bind(this, ALLOW_STUDENT_WRITING_DELETION) }
					className={ this.preferenceClassName(ALLOW_STUDENT_WRITING_DELETION) }>
					Delete Writing
				</a>
				<a onClick={ this.selectPreference.bind(this, BACK_LOG_DATE_PERIOD) }
					className={ this.preferenceClassName(BACK_LOG_DATE_PERIOD) }>
					Log Reading
				</a>
				<a onClick={this.selectPreference.bind(this,QUIZ_LIMIT)}
					className={this.preferenceClassName(QUIZ_LIMIT)}>
					Quiz Hours
				</a>
				<a onClick={ this.selectPreference.bind(this, OWL_SHOP) }
					className={ this.preferenceClassName(OWL_SHOP) }>
					Owl Shop Hours
				</a>
			</div>
		);
	}

	renderSystemSection() {
		if (!CurrentUser.isTeacherAdmin()) {
			return;
		}

		var { activeView } = this.props.locationState;
		return (
			<div className="linksGroup">
				<p>System</p>
				<a onClick={ this.selectPreference.bind(this, GENERAL_ORG_SETTINGS) }
					className={ this.preferenceClassName(GENERAL_ORG_SETTINGS) }>
					Expectations
				</a>
				<a onClick={ this.selectPreference.bind(this, QUIZ_SCORING) }
					className={ this.preferenceClassName(QUIZ_SCORING) }>
					Scoring
				</a>
				<a onClick={ this.selectPreference.bind(this, SOUND_OPTION) }
					className={ this.preferenceClassName(SOUND_OPTION) }>
					Sounds
				</a>
				<a onClick={ this.selectPreference.bind(this, SPEECH_CONTROLS) }
					className={ this.preferenceClassName(SPEECH_CONTROLS) }>
					Voice Options
				</a>
			</div>
		);
	}

	render() {
		var { activeView } = this.props.locationState;

		var accountSettingsLinks = (
			<div className="linksSection">
				{ this.renderAccountSection() }
				{ this.renderOrgSection() }
				{ this.renderContentSection() }
				{ this.renderStudentsSection() }
				{ this.renderSystemSection() }
			</div>
		);
		var header = (
			<header className="pageHeader">
				<h1>{this.getSubHeaderName(activeView)}</h1>
			</header>	
		)

		var currentViewContent = (
			<div className="accountSettingsSection clearfix">
				{ accountSettingsLinks }
				<div className="preferenceArea">
					{ header }
					<Preferences type={ this.getPreferenceName(activeView) } billingHistory={ this.state.billingHistory } />
				</div>	
			</div>
		)

		var pageContent = (
			<div className="">
				<ErrorDisplay ref="errors" />
				{ currentViewContent }
			</div>
		);

		return (
			<div className="settingsPage container">
				{ pageContent }
			</div>
		)
	}
}

var INFORMATION = "information";
var PAYMENT = "payment";
var PLAN = "plan";
var REFERRAL = "referral";
var QUESTION_CUSTOMIZER = "questions";
var ZPD = "reading-level";
var SKILLSET_CUSTOMIZER = "standards";
var DISPLAY_CLASS_SHELF = "class-shelf";
var ALLOW_STUDENT_WRITING_DELETION = "delete-writing";
var BACK_LOG_DATE_PERIOD = "log-reading";
var QUIZ_LIMIT = "quiz-limit"
var OWL_SHOP = "owl-shop";
var SCHOOL_YEAR = "school-year";
var QUIZ_SCORING = "scoring";
var SOUND_OPTION = "sounds";
var SPEECH_CONTROLS = "voice-options";
var ALLOW_STUDENT_QUESTION_BUILDER = "quesion-builder";
var LINK_ACCOUNTS = "link-accounts"
var MERGE_USERS = "merge-users"

// ORG SETUP CHECKLIST
var ROSTERING_METHOD = "rostering-method"
var ACTIVATION_CODES = "activation-codes"
var GENERAL_ORG_SETTINGS = "general_org_settings"
var CODE_TABLE = "code-table"
var SCHOOL_CONTEST = "school-contest"


SettingsPage.propTypes = PageStrictPropTypes({
});

module.exports = SettingsPage;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/SettingsPage.js